import { StyleSheet } from 'react-native'

export const LoginStyle = StyleSheet.create({
  contentContainer: {
    flex: 1,
    maxWidth: 500,
    width: '100%',
  },
})
